import { format, formatDistanceToNow } from 'date-fns'

/**
 * All timestamps from the API are milliseconds since epoch (per project
 * convention) and are rendered in the browser's local timezone.
 */
export function formatTimestamp(ms: number, pattern = 'PP p'): string {
  return format(new Date(ms), pattern)
}

/** "5 minutes ago"-style wording for an API millisecond timestamp. */
export function formatRelativeTimestamp(ms: number): string {
  return formatDistanceToNow(new Date(ms), { addSuffix: true })
}
